import BaseController from "confinus_ui/base_controller";
import { format } from "timeago.js";

export default class TimeagoController extends BaseController {
  public static values = {
    timestamp: { type: String, default: null },
  };

  declare private readonly timestampValue: string;
  private timeoutId!: number;
  private currentAgo!: string;
  private timestamp!: number;

  public connect() {
    super.connect();
    const timeStampString = this.timestampValue || "";
    this.timestamp = parseInt(timeStampString, 10);
    this.render();
  }

  public disconnect() {
    clearTimeout(this.timeoutId);
    super.disconnect();
  }

  private render() {
    // Tick every minute if date is older than 1 minute, tick every second otherwise
    const timeout = Date.now() - this.timestamp > 60000 ? 60000 : 1000;
    const newAgo = format(this.timestamp);

    if (this.currentAgo !== newAgo) {
      this.element.textContent = newAgo;
      this.currentAgo = newAgo;
    }

    this.timeoutId = window.setTimeout(this.render.bind(this), timeout);
  }
}
